/**
 * Created by rickborst on 22/02/2017.
 */

const storage = localStorage;

/**
 * Writes a value to local storage under a given name.
 *
 * @param {string} name - Storage name.
 * @param {string} value - Value string.
 */
export function write (name, value) {

    storage.setItem(name, value);
}

/**
 * Reads a value from local storage under a given name.
 *
 * @param {string} name - Storage name.
 * @returns {string} Item from the storage.
 */
export function read (name) {

    return storage.getItem(name);
}

/**
 * Clears a value from local storage under a given name.
 *
 * @param {string} name - Storage name.
 */
export function clear (name) {

    storage.removeItem(name);
}


// WEBPACK FOOTER //
// ./src/js/storage/manager/local.js